import { useState } from "react";

import SignupModal from "@/components/signup-modal";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useIsBreakPoint } from "@/hooks/use-is-break-point";

import type { GameSortOptionsEnum } from "../../types";
import type { SortOptionsType } from "./constants";
import { SORT_OPTIONS_CONFIG } from "./constants";
import DesktopMenu from "./desktop-menu";
import { DownIcon } from "./icons";
import MobileModal from "./mobile-modal";

interface SortButtonProps {
  href: string;
  isCurrentUser: boolean;
  options?: SortOptionsType;
  sortBy: GameSortOptionsEnum;
}

export default function SortButton({
  href,
  isCurrentUser,
  options = SORT_OPTIONS_CONFIG,
  sortBy,
}: SortButtonProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);
  const isDesktop = useIsBreakPoint("md");

  const onClick = () => setIsMenuOpen(false);

  const props = {
    href,
    isCurrentUser,
    onClick,
    onSignup: () => setIsSignupModalOpen(true),
    options,
    sortBy,
  };

  return (
    <>
      <Popover onOpenChange={setIsMenuOpen} open={isMenuOpen}>
        <PopoverTrigger className="group flex h-7 items-center gap-2 rounded-[14px] border border-white/50 px-2.5 font-medium text-12 text-white hover:bg-white/10">
          {options[sortBy]?.icon}
          {options[sortBy]?.name}
          <DownIcon className="transition-transform group-has-data[state=open]:rotate-180" />
        </PopoverTrigger>
        {isDesktop ? (
          <PopoverContent className="w-auto min-w-72 border-0 bg-transparent shadow-none">
            <DesktopMenu {...props} />
          </PopoverContent>
        ) : (
          <MobileModal
            onOpenChange={setIsMenuOpen}
            open={isMenuOpen}
            {...props}
          />
        )}
      </Popover>
      <SignupModal
        onOpenChange={setIsSignupModalOpen}
        open={isSignupModalOpen}
      />
    </>
  );
}
